import React from "react";
import { createRoot } from "react-dom/client";
import "animate.css";
import "bootstrap/dist/css/bootstrap.css";

import "../common/base.scss";

const container = document.querySelector("#root");
const root = createRoot(container);

export function renderMain(Main: React.ReactElement) {
  root.render(Main);
}
